import React from "react";
import {Navigate, useRoutes} from "react-router";
import ListOfIntCollRequests from "../features/collection-requests/ListOfIntCollRequests";
import ReportEditorPage from "../features/products/reportEditorPage/ReportEditorPage";
import ReportMentionsPage from "../features/products/reportMentionsPage/ReportMentionsPage";
import AppRealUser from "../apps/real_user/appRealUser";
import ReportPreviewPage from "../features/products/previewPage/ReportPreviewPage";
import {ReportPageLayout} from "../features/products/reportPage";
import IcrPage from "../features/collection-requests/IcrPage";
import EeiPage from "../features/collection-requests/EeiPage";
import GapPage from "../features/collection-requests/GapPage";
import {routesChat} from "./routesChat";
import AllProductsPage from "../features/products/pages/AllProductsPage";
import KnowledgeBasePage from "../features/knowledgeBase/KnowledgeBasePage";
import EntitiesList from "../features/knowledgeBase/EntitiesList";
import EntityDetailPage from "../features/knowledgeBase/EntityDetailPage";
import WhiteboardsListPage from "../features/whiteboards/WhiteboardsListPage";
import WhiteboardPage from "../features/whiteboards/WhiteboardPage";
import HelpPage from "../features/help/HelpPage";
import LegacyRfiRedirect from "./LegacyRfiRedirect";
import LegacyWhiteboardRedirect from "./LegacyWhiteboardRedirect";
import TagBrowsePage from "../features/collection-requests/tags/TagBrowsePage";
import {collectionDeepLinkRoutes} from "./collectionRoutes";

const routesRealUser = [
    ...routesChat,
    {
        path: "/",
        element: <AppRealUser/>,
        children: [
            {index: true, element: <Navigate to="products" replace/>},
            {path: "/icr/eei/:eeiNumber", element: <EeiPage/>},
            {path: "/icr/gap/:gapNumber", element: <GapPage/>},
            {path: "/icr/:icrNumber", element: <IcrPage/>},
            {path: "/icr", element: <ListOfIntCollRequests/>},
            {path: "/tags/:tag", element: <TagBrowsePage/>},
            {path: "/rfi", element: <Navigate to="/icr" replace/>},
            {path: "/rfi/*", element: <LegacyRfiRedirect/>},
            ...collectionDeepLinkRoutes,
            {path: "products", element: <AllProductsPage/>},
            {path: "charts", element: <WhiteboardsListPage/>},
            {path: "help", element: <HelpPage/>},
            {
                path: "kb",
                element: <KnowledgeBasePage/>,
                children: [
                    {index: true, element: <EntitiesList/>},
                    {path: ":entityId", element: <EntityDetailPage/>},
                ],
            },
        ],
    },
    {
        path: "/products/:reportId",
        element: <ReportPageLayout/>,
        children: [
            {path: "edit", element: <ReportEditorPage/>},
            {path: "mentions", element: <ReportMentionsPage/>},
            {path: "preview", element: <ReportPreviewPage/>},
        ],
    },
    {
        path: "/charts/:whiteboardId",
        element: <WhiteboardPage/>,
    },
    {path: "/whiteboards", element: <Navigate to="/charts" replace/>},
    {path: "/whiteboards/*", element: <LegacyWhiteboardRedirect/>},
    {path: "*", element: <Navigate to="/products" replace/>},
];

export function RoutesRealUser() {
    return useRoutes(routesRealUser);
}
